import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const ADMIN_API_BASE = `${BACKEND_URL}/api/admin`;

// Separate axios instance — admin token never collides with customer/restaurant tokens.
const adminApi = axios.create({ baseURL: ADMIN_API_BASE });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("cravve-admin-token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("cravve-admin-token");
    }
    return Promise.reject(err);
  }
);

export default adminApi;
